import React, { useEffect, useState } from "react";
import {
    loadCaptchaEnginge,
    validateCaptcha,
    LoadCanvasTemplateNoReload
} from "react-simple-captcha";
import Header from "./Header";

interface Certificate {
    number: string;
    title: string;
    duration: string;
    status: string;
    name: string;
}

const CertificateValidation: React.FC = () => {
    const [growniverse, setGrowniverse] = useState("");
    const [email, setEmail] = useState("");
    const [dob, setDob] = useState("");
    const [screen, setScreen] = useState<"entry" | "list">("entry");
    const [isValid, setIsValid] = useState<boolean | null>(null);
    const [captchaInput, setCaptchaInput] = useState("");
    const [invalidCaptcha, setInvalidCaptcha] = useState(false);

    const certificates: Certificate[] = [
        {
            number: "IN-291201",
            title: "Internship Certificate - Sales and Marketing",
            duration: "8 June 2026 – 24 July 2026",
            status: "Completed",
            name: "Navneet Kumar"
        }
    ];

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateCaptcha(captchaInput)) {
            setInvalidCaptcha(true);
            return;
        }

        const formattedDob = dob
            ? new Date(dob).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
            })
            : "";

        if (
            growniverse === "G100210" &&
            email === "navneetrai050@gmail.com" &&
            formattedDob === "2 May 1999" &&
            captchaInput
        ) {
            setIsValid(true);
            setScreen("list");
        } else {
            setIsValid(false);
        }
    };

    const handleBack = () => {
        window.location.reload();
    };

    useEffect(() => {
        loadCaptchaEnginge(6); // 6 characters

        const styles = `
        @keyframes fadeInUp {
            from {
                opacity: 0;
                transform: translateY(40px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
        `;
        const styleSheet = document.createElement("style");
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet);
    }, []);

    return (
        <>
            <Header />
            <div style={pageStyle}>
                {screen === "entry" && (
                    <div style={cardStyle}>
                        <form onSubmit={handleSubmit}>
                            <label style={labelStyle}>Growniverse ID</label>
                            <input
                                type="text"
                                value={growniverse}
                                onChange={(e) => setGrowniverse(e.target.value)}
                                required
                                style={inputStyle}
                            />

                            <label style={labelStyle}>Email ID</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                style={inputStyle}
                            />

                            <label style={labelStyle}>Date of Birth</label>
                            <input
                                type="date"
                                value={dob}
                                onChange={(e) => setDob(e.target.value)}
                                required
                                style={inputStyle}
                            />

                            {/* Captcha */}
                            <div style={{ margin: "20px 0" }}>
                                <LoadCanvasTemplateNoReload />
                                <input
                                    type="text"
                                    placeholder="Enter Captcha"
                                    value={captchaInput}
                                    onChange={(e) => { setCaptchaInput(e.target.value); setInvalidCaptcha(false); }}
                                    required
                                    style={inputStyle}
                                />
                                {invalidCaptcha && (
                                    <span style={{ color: "red" }}>Invalid Captcha</span>
                                )}
                            </div>

                            <button type="submit" style={buttonStyle}>
                                SUBMIT
                            </button>
                        </form>

                        {isValid === false && (
                            <div
                                style={{
                                    marginTop: "20px",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    background: "#f8d7da",          // soft red background
                                    border: "1px solid #f5c2c7",    // subtle border
                                    textAlign: "center",
                                    fontWeight: 500,
                                    color: "#842029",               // dark red text
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)", // light shadow
                                }}
                            >
                                <span style={{ fontSize: "20px", marginRight: "8px" }}>❌</span>
                                <strong>Certificate Not Found</strong>
                            </div>

                        )}
                    </div>
                )}

                {screen === "list" && (
                    <div style={cardStyle}>
                        <h1 style={titleStyle}>Your Certificates</h1>
                        {certificates.map((cert, idx) => (
                            <div key={idx} style={successBoxStyle}>
                                <h2 style={{ color: "#4da6ff" }}>
                                    📜 {cert.title} ✅</h2>
                                <p><strong>Name:</strong> {cert.name}</p>
                                <p><strong>Certificate Number:</strong> {cert.number}</p>
                                <p><strong>Duration:</strong> {cert.duration}</p>
                                <p><strong>Status:</strong> {cert.status}</p>
                            </div>
                        ))}
                        <button
                            onClick={handleBack}
                            style={{ ...buttonStyle, marginTop: "20px", background: "#555" }}
                        >
                            ⬅ Back
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

// Styles
const pageStyle: React.CSSProperties = {
    fontFamily: "Segoe UI, Roboto, Arial, sans-serif",
    background: "linear-gradient(135deg, #1a1a1d, #2c2c34)",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
    color: "#eaeaea",
};

const cardStyle: React.CSSProperties = {
    maxWidth: "700px",
    width: "100%",
    background: "#2c2c34",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.6)",
    animation: "fadeInUp 0.8s ease"
};

const titleStyle: React.CSSProperties = {
    textAlign: "center",
    marginBottom: "30px",
    color: "#ffcc00", // 🌟 changed from dull black to golden yellow
};

const labelStyle: React.CSSProperties = {
    fontWeight: "bold",
    marginTop: "10px",
    display: "block",
};

const inputStyle: React.CSSProperties = {
    width: "100%",
    padding: "12px",
    margin: "8px 0 16px 0",
    border: "1px solid #555",
    borderRadius: "6px",
    fontSize: "15px",
    background: "#ececec",
    color: "#000",
};

const buttonStyle: React.CSSProperties = {
    width: "100%",
    padding: "14px",
    background: "#4da6ff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: "10px",
};

const successBoxStyle: React.CSSProperties = {
    marginTop: "20px",
    padding: "20px",
    borderRadius: "8px",
    background: "#1d3d1d",
    color: "#a6f3a6",
};

const errorBoxStyle: React.CSSProperties = {
    marginTop: "20px",
    padding: "20px",
    borderRadius: "8px",
    background: "#3d1d1d",
    textAlign: "center",
    fontWeight: "bold",
    color: "#f3a6a6",
};

export default CertificateValidation;
